import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AmostraService } from 'src/app/services/amostra.service';

@Component({
  selector: 'app-imprimir-folhas-testes',
  templateUrl: './imprimir-folhas-testes.component.html',
  styleUrls: ['./imprimir-folhas-testes.component.scss']
})
export class ImprimirFolhasTestesComponent implements OnInit {
  model: any;
  id: number = 0;
  idAmostra: any
  nomeAmostra: any
  Ug: any

  constructor(
    private router: Router,
    public route: ActivatedRoute,
    private amostraService: AmostraService) {
    const id = this.route.snapshot.paramMap.get("id");
    const path = this.route.snapshot.url.pop()?.toString();
    if (id) {
      this.id = parseInt(id, 10);
    }
    const navigation = this.router.getCurrentNavigation();
    this.idAmostra = navigation?.extras?.state?.['idAmostra'];
    this.getAmostra('planejamento')
  }

  ngOnInit(): void {
    // this.getAmostra('planejamento')
  }

  getAmostra(tipoAmostra: any) {
    this.amostraService
      .obterAmostraId(this.id, this.idAmostra, tipoAmostra)
      .then((res) => {
        this.nomeAmostra = res.dados?.nome
        this.Ug = `${res.dados?.amostraUnidadeGestoras[0]?.unidadeGestora.nome}-${res.dados?.amostraUnidadeGestoras[0]?.unidadeGestora.sigla}`;
        this.model = this.extrairProcedimentosEcriterios(res.dados?.planejamentoAmostraMatrizQuestoes)
      })
      .catch((err) => {
      })
  }

  extrairTextoLimpo(html: string): string {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    return tempDiv.textContent?.trim() ?? '';
  }

  extrairProcedimentosEcriterios(dados: any[]): { procedimento: string; criterioAplicavel: string; codigo: string }[] {
    const resultado: any[] = [];

    const dadosOrdenados = [...dados].sort((a, b) => {
      const ordemA = a.questaoPlanejamento?.ordem ?? 0;
      const ordemB = b.questaoPlanejamento?.ordem ?? 0;
      return ordemA - ordemB;
    });

    dadosOrdenados.forEach((item, indexQuestao) => {
      const questao = item.questaoPlanejamento;

      resultado.push({
        codigo: `Q.${(questao.ordem).toString().padStart(2, '0')}`,
        procedimento: this.extrairTextoLimpo(questao.nome),
        criterioAplicavel: this.extrairTextoLimpo(questao.legislacaoAplicavelCriterio),
      });

      const procedimentos = questao.questaoProcedimentoAuditoria || [];

      procedimentos.forEach((pa, indexProcedimento) => {
        resultado.push({
          codigo: `P.${(questao.ordem).toString().padStart(2, '0')}.${(indexProcedimento + 1).toString().padStart(2, '0')}`,
          procedimento: this.extrairTextoLimpo(pa.procedimentoAuditoria?.nome),
          criterioAplicavel: ''
        });
      });
    });

    return resultado;
  }



  cancelar() {
    this.router.navigate([`planejamento/${this.id}/planejar`], { state: { aba: 10 } })
  }
}
